import { render, staticRenderFns } from "./a-base-info.vue?vue&type=template&id=1b3ca565&"
import script from "./a-base-info.vue?vue&type=script&lang=js&"
export * from "./a-base-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports